
export enum DocumentStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  NEEDS_INFO = 'NEEDS_INFO'
}

export enum DocumentAction {
  UPLOAD = 'UPLOAD',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  REQUEST_INFO = 'REQUEST_INFO'
}

export enum DocumentVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}

export enum IdentificationTypeEnum {
  NID = 'NID',
  FOREIGN_ID = 'FOREIGN_ID',
  PASSPORT = 'PASSPORT'
}

export enum DocumentCodeEnum {
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
  ARTICLES_OF_ASSOCIATION = 'ARTICLES_OF_ASSOCIATION',
  OFFICE_PAYMENT = 'OFFICE_PAYMENT',
  VIRTUAL_OFFICE_AGREEMENT = 'VIRTUAL_OFFICE_AGREEMENT',
  OFFICE_LEASE_AGREEMENT = 'OFFICE_LEASE_AGREEMENT',
  REGISTRATION_FEE = 'REGISTRATION_FEE',
  DIRECTOR_ID = 'DIRECTOR_ID',
  SHAREHOLDER_ID = 'SHAREHOLDER_ID',
  FOREIGN_CERTIFICATE_OF_INCORPORATION = 'FOREIGN_CERTIFICATE_OF_INCORPORATION',
  CONSTITUTIONAL_DOCUMENTS = 'CONSTITUTIONAL_DOCUMENTS',
  LOCAL_REPRESENTATIVE_ID = 'LOCAL_REPRESENTATIVE_ID',
  VAT_PAYMENT = 'VAT_PAYMENT',
  VAT_CERTIFICATE = 'VAT_CERTIFICATE',
  ACCEPTANCE_OF_DUTIES = 'ACCEPTANCE_OF_DUTIES',
  TRUST_DOCUMENT = 'TRUST_DOCUMENT',
  TRUSTEES_ACCEPTANCE = 'TRUSTEES_ACCEPTANCE',
  APPOINTMENT_DOCUMENT = 'APPOINTMENT_DOCUMENT',
  BOARD_RESOLUTION = 'BOARD_RESOLUTION',
  SHARE_CERTIFICATE = 'SHARE_CERTIFICATE',
  SUPPORTING_DOCUMENT = 'SUPPORTING_DOCUMENT',
  CRB_DOCUMENT = 'CRB_DOCUMENT',
  ZIMRA_DOCUMENT = 'ZIMRA_DOCUMENT',
  COURT_CLEARANCE_DOCUMENT = 'COURT_CLEARANCE_DOCUMENT',
  CERTIFICATE_OF_DISSOLUTION = 'CERTIFICATE_OF_DISSOLUTION',
  BRANCH_RESOLUTION = 'BRANCH_RESOLUTION',
  SIGNATURE = 'SIGNATURE',
  PASSPORT = 'PASSPORT',
  NATIONAL_ID = 'NATIONAL_ID',
  BUSINESS_LICENSE = 'BUSINESS_LICENSE',
  SHAREHOLDER_REGISTER = 'SHAREHOLDER_REGISTER',
  INVESTMENT_CERTIFICATE = 'INVESTMENT_CERTIFICATE',
  COMPANY_CERTIFICATE = 'COMPANY_CERTIFICATE',
  KYC_DOCUMENT = 'KYC_DOCUMENT',
  INVESTMENT_DOCUMENT = 'INVESTMENT_DOCUMENT',
  PROOF_OF_INCOME = 'PROOF_OF_INCOME',
  PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
  TAX_CLEARANCE = 'TAX_CLEARANCE',
  PROOF_OF_PAYMENT = 'PROOF_OF_PAYMENT',

  //licensing documents
  //  COMMON FOR ALL LICENSEES 
  BOARD_RESOLUTION_APPROVING_LICENSE_APPLICATION = 'BOARD_RESOLUTION_APPROVING_LICENSE_APPLICATION', // All LICENSEs
  BUSINESS_PLAN = 'BUSINESS_PLAN', // All LICENSEs
  AML_CFT_POLICY = 'AML_CFT_POLICY', // All LICENSEs
  RISK_MANAGEMENT_POLICY = 'RISK_MANAGEMENT_POLICY', // All LICENSEs

  //  COMMON ACROSS SOME SECTORS 
  COMPLIANCE_MANUAL = 'COMPLIANCE_MANUAL', // Banking, Capital Markets, Fintech
  PROFESSIONAL_INDEMNITY_INSURANCE_CERTIFICATE = 'PROFESSIONAL_INDEMNITY_INSURANCE_CERTIFICATE', // Insurance Broker, Ancillary
  CONFLICT_OF_INTEREST_POLICY = 'CONFLICT_OF_INTEREST_POLICY', // Merchant Bank, Investment Advisor, Business Consulting Firm
  CAPITAL_ADEQUACY_PLAN = 'CAPITAL_ADEQUACY_PLAN', // Reinsurance, Full Bank (ICAAP)
  IT_ARCHITECTURE_DIAGRAM = 'IT_ARCHITECTURE_DIAGRAM', // Digital Bank, Stock/Crypto Exchange, Fintech Full Custodial LICENSE
  CYBERSECURITY_POLICY = 'CYBERSECURITY_POLICY', // Digital Bank, Stock/Crypto Exchange, Fintech Full Custodial LICENSE
  BUSINESS_CONTINUITY_PLAN = 'BUSINESS_CONTINUITY_PLAN', // Digital Bank, Stock/Crypto Exchange, Fintech Full Custodial LICENSE
  DATA_PROTECTION_POLICY = 'DATA_PROTECTION_POLICY', // Digital Bank, Fintech sector
  IT_GOVERNANCE_FRAMEWORK = 'IT_GOVERNANCE_FRAMEWORK', // Fintech sector
  INCIDENT_RESPONSE_PLAN = 'INCIDENT_RESPONSE_PLAN', // Digital Bank, Digital Asset Service Provider (Fintech)
  INDEPENDENCE_POLICY = 'INDEPENDENCE_POLICY', //accounting and auditing firm ,  Credit Rating Agency
  KEY_MANAGEMENT_PROCEDURE = 'KEY_MANAGEMENT_PROCEDURE', // Fintech Full Custodial LICENSE , AND Digital Asset Service Provider (Fintech)  ,
  RESPONSIBLE_GAMBLING_PLAYER_PROTECTION_POLICY = 'RESPONSIBLE_GAMBLING_PLAYER_PROTECTION_POLICY', // ALL Gaming




  //  BANKING 
  ORGANIZATION_STRUCTURE_CHART = 'ORGANIZATION_STRUCTURE_CHART',

  // Investment Bank
  TRADING_POLICY = 'TRADING_POLICY',
  MARKET_RISK_MANAGEMENT_POLICY = 'MARKET_RISK_MANAGEMENT_POLICY',
  CLIENT_ASSET_PROTECTION_POLICY = 'CLIENT_ASSET_PROTECTION_POLICY',

  // Merchant Bank
  CORPORATE_FINANCE_POLICY = 'CORPORATE_FINANCE_POLICY',
  ADVISORY_FRAMEWORK = 'ADVISORY_FRAMEWORK',

  // Commercial Bank
  DEPOSIT_POLICY = 'DEPOSIT_POLICY',
  LIQUIDITY_RISK_POLICY = 'LIQUIDITY_RISK_POLICY',
  CONTINGENCY_FUNDING_PLAN = 'CONTINGENCY_FUNDING_PLAN',
  CREDIT_RISK_POLICY = 'CREDIT_RISK_POLICY',
  CORE_BANKING_SYSTEM_DESCRIPTION = 'CORE_BANKING_SYSTEM_DESCRIPTION',
  INTERNAL_AUDIT_FRAMEWORK = 'INTERNAL_AUDIT_FRAMEWORK',

  // Full Bank
  ICAAP_CAPITAL_ADEQUACY_REPORT = 'ICAAP_CAPITAL_ADEQUACY_REPORT',
  LIQUIDITY_STRESS_TESTING_FRAMEWORK = 'LIQUIDITY_STRESS_TESTING_FRAMEWORK',
  TREASURY_RISK_POLICY = 'TREASURY_RISK_POLICY',
  GROUP_STRUCTURE_DOCUMENTS = 'GROUP_STRUCTURE_DOCUMENTS',

  // Mortgage Bank
  MORTGAGE_UNDERWRITING_POLICY = 'MORTGAGE_UNDERWRITING_POLICY',
  COLLATERAL_VALUATION_POLICY = 'COLLATERAL_VALUATION_POLICY',
  ARREARS_MANAGEMENT_POLICY = 'ARREARS_MANAGEMENT_POLICY',
  LOAN_PROVISIONING_POLICY = 'LOAN_PROVISIONING_POLICY',

  // Digital Bank
  PROOF_OF_MINIMUM_CAPITAL = 'PROOF_OF_MINIMUM_CAPITAL',
  DISASTER_RECOVERY_PLAN = 'DISASTER_RECOVERY_PLAN',
  OUTSOURCING_POLICY = 'OUTSOURCING_POLICY',
  DIGITAL_CUSTOMER_TERMS_AND_CONDITIONS = 'DIGITAL_CUSTOMER_TERMS_AND_CONDITIONS',
  REMOTE_KYC_PROCEDURE = 'REMOTE_KYC_PROCEDURE',

  // Representative Office
  PARENT_BANK_LICENSE_COPY = 'PARENT_BANK_LICENSE_COPY',
  HOME_REGULATOR_NO_OBJECTION_LETTER = 'HOME_REGULATOR_NO_OBJECTION_LETTER',
  BOARD_RESOLUTION_FOR_REPRESENTATIVE_OFFICE = 'BOARD_RESOLUTION_FOR_REPRESENTATIVE_OFFICE',
  REPRESENTATIVE_OFFICE_BUSINESS_PLAN = 'REPRESENTATIVE_OFFICE_BUSINESS_PLAN',

  //  CAPITAL MARKETS 
  // Dealer/Broker
  BROKERAGE_OPERATIONS_MANUAL = 'BROKERAGE_OPERATIONS_MANUAL',
  CLIENT_ASSET_SEGREGATION_POLICY = 'CLIENT_ASSET_SEGREGATION_POLICY',
  MARKET_CONDUCT_POLICY = 'MARKET_CONDUCT_POLICY',

  // Investment Advisor
  ADVISORY_SERVICES_POLICY = 'ADVISORY_SERVICES_POLICY',
  CLIENT_DISCLOSURE_TEMPLATES = 'CLIENT_DISCLOSURE_TEMPLATES',

  // Stock 
  EXCHANGE_RULEBOOK = 'EXCHANGE_RULEBOOK',
  LISTING_RULES = 'LISTING_RULES',
  MARKET_SURVEILLANCE_FRAMEWORK = 'MARKET_SURVEILLANCE_FRAMEWORK',
  IT_ARCHITECTURE_DIAGRAM_EXCHANGE = 'IT_ARCHITECTURE_DIAGRAM_EXCHANGE',
  BUSINESS_CONTINUITY_PLAN_EXCHANGE = 'BUSINESS_CONTINUITY_PLAN_EXCHANGE',

  // Crypto Exchange
  DIGITAL_ASSET_CUSTODY_FRAMEWORK = 'DIGITAL_ASSET_CUSTODY_FRAMEWORK',
  CYBERSECURITY_POLICY_EXCHANGE = 'CYBERSECURITY_POLICY_EXCHANGE',

  // Central Securities Depository 
  CUSTODY_DEPOSITORY_OPERATIONS_FRAMEWORK = 'CUSTODY_DEPOSITORY_OPERATIONS_FRAMEWORK',
  ASSET_SEGREGATION_POLICY = 'ASSET_SEGREGATION_POLICY',
  RECONCILIATION_PROCEDURES = 'RECONCILIATION_PROCEDURES',
  RECORD_KEEPING_SYSTEM_DESCRIPTION = 'RECORD_KEEPING_SYSTEM_DESCRIPTION',
  SECURITY_CONTROLS_FOR_ASSET_PROTECTION = 'SECURITY_CONTROLS_FOR_ASSET_PROTECTION',

  // Clearing House
  CLEARING_RULES = 'CLEARING_RULES',
  MARGIN_METHODOLOGY = 'MARGIN_METHODOLOGY',
  LIQUIDITY_RISK_FRAMEWORK = 'LIQUIDITY_RISK_FRAMEWORK',
  DEFAULT_MANAGEMENT_PROCEDURES = 'DEFAULT_MANAGEMENT_PROCEDURES',
  SETTLEMENT_PROCEDURES = 'SETTLEMENT_PROCEDURES',
  STRESS_TESTING_FRAMEWORK = 'STRESS_TESTING_FRAMEWORK',

  // CIS 
  FUND_PROSPECTUS_TEMPLATE = 'FUND_PROSPECTUS_TEMPLATE',
  VALUATION_POLICY = 'VALUATION_POLICY',
  INVESTMENT_STRATEGY = 'INVESTMENT_STRATEGY',
  INVESTOR_DISCLOSURE_POLICY = 'INVESTOR_DISCLOSURE_POLICY',

  // CIS Fund Manager
  PORTFOLIO_MANAGEMENT_FRAMEWORK = 'PORTFOLIO_MANAGEMENT_FRAMEWORK',
  INTERNAL_CONTROLS_FRAMEWORK = 'INTERNAL_CONTROLS_FRAMEWORK',
  GOVERNANCE_STRUCTURE = 'GOVERNANCE_STRUCTURE',
  //CIS Trustee
  CUSTODY_AGREEMENT = 'CUSTODY_AGREEMENT',
  ASSET_SAFEKEEPING_PROCEDURES = 'ASSET_SAFEKEEPING_PROCEDURES',
  OVERSIGHT_FRAMEWORK = 'OVERSIGHT_FRAMEWORK',

  // Credit Rating Agency
  RATING_METHODOLOGY = 'RATING_METHODOLOGY',

  // Custody / Wallet Services
  CUSTODY_POLICY = 'CUSTODY_POLICY',
  CLIENT_ASSET_SAFEGUARDING_POLICY = 'CLIENT_ASSET_SAFEGUARDING_POLICY',

  // Crowdfunding Platform
  PLATFORM_OPERATION_RULES = 'PLATFORM_OPERATION_RULES',
  INVESTOR_PROTECTION_POLICY = 'INVESTOR_PROTECTION_POLICY',
  ESCROW_PAYMENT_HANDLING_FRAMEWORK = 'ESCROW_PAYMENT_HANDLING_FRAMEWORK',

  //  INSURANCE 
  // General Insurance
  UNDERWRITING_POLICY = 'UNDERWRITING_POLICY',
  CLAIMS_MANAGEMENT_POLICY = 'CLAIMS_MANAGEMENT_POLICY',
  REINSURANCE_POLICY = 'REINSURANCE_POLICY',
  ACTUARIAL_REPORT = 'ACTUARIAL_REPORT',

  // Long-Term (Life) Insurance
  LIFE_PRODUCT_POLICY = 'LIFE_PRODUCT_POLICY',
  ACTUARIAL_VALUATION_METHODOLOGY = 'ACTUARIAL_VALUATION_METHODOLOGY',
  INVESTMENT_POLICY = 'INVESTMENT_POLICY',

  // Reinsurance
  REINSURANCE_TREATIES = 'REINSURANCE_TREATIES',
  COUNTERPARTY_RISK_POLICY = 'COUNTERPARTY_RISK_POLICY',

  // Insurance Broker
  BROKER_CONDUCT_POLICY = 'BROKER_CONDUCT_POLICY',
  CLIENT_MONEY_HANDLING_POLICY = 'CLIENT_MONEY_HANDLING_POLICY',

  // Insurance Agency
  AGENCY_AGREEMENT_TEMPLATE = 'AGENCY_AGREEMENT_TEMPLATE',
  CLIENT_DISCLOSURE_POLICY = 'CLIENT_DISCLOSURE_POLICY',

  //  ANCILLARY SERVICES 

  //all
  PROFESSIONAL_INDEMNITY_INSURANCE_CERTIFICATE_ANCILLARY = 'PROFESSIONAL_INDEMNITY_INSURANCE_CERTIFICATE_ANCILLARY',
  PROFESSIONAL_INDEMNITY_INSURANCE_CERTIFICATE_INSURANCE_AGENCY = 'PROFESSIONAL_INDEMNITY_INSURANCE_CERTIFICATE_INSURANCE_AGENCY',
  // Legal Services Firm
  LAW_SOCIETY_BAR_REGISTRATION_CERTIFICATE = 'LAW_SOCIETY_BAR_REGISTRATION_CERTIFICATE',
  CODE_OF_PROFESSIONAL_CONDUCT = 'CODE_OF_PROFESSIONAL_CONDUCT',

  // Accounting / Auditing Firm
  PROFESSIONAL_BODY_REGISTRATION = 'PROFESSIONAL_BODY_REGISTRATION',
  QUALITY_ASSURANCE_FRAMEWORK = 'QUALITY_ASSURANCE_FRAMEWORK',
  INDEPENDENCE_POLICY_ACCOUNTING_FIRM = 'INDEPENDENCE_POLICY_ACCOUNTING_FIRM',

  // Corporate Services Provider / Company Formation Agent
  CLIENT_ONBOARDING_KYC_PROCEDURES = 'CLIENT_ONBOARDING_KYC_PROCEDURES',
  RECORD_KEEPING_POLICY = 'RECORD_KEEPING_POLICY',

  // Business Consulting Firm
  SERVICE_ENGAGEMENT_FRAMEWORK = 'SERVICE_ENGAGEMENT_FRAMEWORK',
  CONFLICT_OF_INTEREST_POLICY_BUSINESS_CONSULTING = 'CONFLICT_OF_INTEREST_POLICY_BUSINESS_CONSULTING',

  //  FINTECH 
  // Sandbox LICENSE
  INNOVATION_PROPOSAL = 'INNOVATION_PROPOSAL',
  TESTING_PLAN = 'TESTING_PLAN',
  RISK_DISCLOSURE_TO_USER = 'RISK_DISCLOSURE_TO_USER',

  // Full Custodial LICENSE
  CUSTODY_POLICY_FINTECH = 'CUSTODY_POLICY_FINTECH',
  CLIENT_ASSET_SEGREGATION_FRAMEWORK = 'CLIENT_ASSET_SEGREGATION_FRAMEWORK',

  // Full Non-Custodial LICENSE
  PLATFORM_OPERATIONS_POLICY = 'PLATFORM_OPERATIONS_POLICY',
  SMART_CONTRACT_AUDIT_REPORT = 'SMART_CONTRACT_AUDIT_REPORT', // optional

  // Token Issuance Platform
  TOKEN_WHITE_PAPER = 'TOKEN_WHITE_PAPER',
  TOKENOMICS_STRUCTURE = 'TOKENOMICS_STRUCTURE',
  INVESTOR_DISCLOSURE_STATEMENT = 'INVESTOR_DISCLOSURE_STATEMENT',

  // Payment Services Provider
  PAYMENT_FLOW_ARCHITECTURE = 'PAYMENT_FLOW_ARCHITECTURE',
  SAFEGUARDING_OF_CLIENT_FUNDS_POLICY = 'SAFEGUARDING_OF_CLIENT_FUNDS_POLICY',

  // Digital Asset Service Provider
  WALLET_MANAGEMENT_POLICY = 'WALLET_MANAGEMENT_POLICY',


  //  GAMING 
  LOTTO_GAME_RULES = 'LOTTO_GAME_RULES',
  DRAW_INTEGRITY_PROCEDURE = 'DRAW_INTEGRITY_PROCEDURE',
  PRIZE_PAYOUT_PROCEDURE = 'PRIZE_PAYOUT_PROCEDURE',

  CASINO_GAME_RULES = 'CASINO_GAME_RULES',
  CYBERSECURITY_POLICY_CASINO = 'CYBERSECURITY_POLICY_CASINO',
  PLAYER_FUNDS_SAFEGUARDING_POLICY = 'PLAYER_FUNDS_SAFEGUARDING_POLICY',

  BETTING_RULES = 'BETTING_RULES',
  ODDS_RISK_MANAGEMENT_POLICY = 'ODDS_RISK_MANAGEMENT_POLICY',
  INTEGRITY_ANTI_MATCH_FIXING_PROCEDURES = 'INTEGRITY_ANTI_MATCH_FIXING_PROCEDURES',
  SETTLEMENT_PAYOUT_PROCEDURE = 'SETTLEMENT_PAYOUT_PROCEDURE',

  //license review 
  LICENSING_COMMITEE_RESOLUTION = 'LICENSING_COMMITEE_RESOLUTION',

  //PROVISIONAL
  OPERATIONAL_LICENCE = 'OPERATIONAL_LICENCE',
  CERTIFICATE_OF_INCORPORATION = 'CERTIFICATE_OF_INCORPORATION',
  PROOF_OF_REGULATORY_GOOD_STANDING = 'PROOF_OF_REGULATORY_GOOD_STANDING',
  COMPANY_PROFILE_BUSINESS_OVERVIEW = 'COMPANY_PROFILE_BUSINESS_OVERVIEW',
  DIRECTORS_LIST = 'DIRECTORS_LIST',
  SHAREHOLDING_STRUCTURE = 'SHAREHOLDING_STRUCTURE',

  OTHER = 'OTHER'
}

export enum ClosureReason {
  SHAREHOLDER_DISPUTE = 'SHAREHOLDER_DISPUTE',
  VOLUNTARY_CLOSURE_OF_BUSINESS = 'VOLUNTARY_CLOSURE_OF_BUSINESS',
  INSOLVENCY = 'INSOLVENCY',
  LOSS_OF_MARKET = 'LOSS_OF_MARKET',
  LACK_OF_FINANCE = 'LACK_OF_FINANCE',
  COURT_ORDER = 'COURT_ORDER',
  OTHER = 'OTHER'
}

